/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BCCADMINAPIControllersStorageMetadataUpdate } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsStorageBrowseResponse } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsStorageRecompressAllResult } from '../Models';
// @ts-ignore
import type { BCCADMINServicesServicesMediaOrphanReport } from '../Models';
// @ts-ignore
import type { StorageObject } from '../Models';
// @ts-ignore
import type { StorageTaxonomyUpdate } from '../Models';
/**
 * StorageApi - axios parameter creator
 */
export const StorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [path] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageBrowseGet: async (path?: string, page?: number, limit?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/storage/browse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageByKeyGet: async (key?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/storage/by-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [folder] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageGet: async (folder?: string, limit?: number, page?: number, search?: string, taxonomyIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folder !== undefined) {
                localVarQueryParameter['folder'] = folder;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (taxonomyIds !== undefined) {
                localVarQueryParameter['taxonomyIds'] = taxonomyIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdDelete', 'id', id)
            const localVarPath = `/api/storage/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdDownloadGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdDownloadGet', 'id', id)
            const localVarPath = `/api/storage/{id}/download`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdGet', 'id', id)
            const localVarPath = `/api/storage/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {BCCADMINAPIControllersStorageMetadataUpdate} [bCCADMINAPIControllersStorageMetadataUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdPut: async (id: string, bCCADMINAPIControllersStorageMetadataUpdate?: BCCADMINAPIControllersStorageMetadataUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdPut', 'id', id)
            const localVarPath = `/api/storage/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bCCADMINAPIControllersStorageMetadataUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdRecompressPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdRecompressPost', 'id', id)
            const localVarPath = `/api/storage/{id}/recompress`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {StorageTaxonomyUpdate} [storageTaxonomyUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdTaxonomiesPut: async (id: string, storageTaxonomyUpdate?: StorageTaxonomyUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdTaxonomiesPut', 'id', id)
            const localVarPath = `/api/storage/{id}/taxonomies`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storageTaxonomyUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdUsagesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStorageIdUsagesGet', 'id', id)
            const localVarPath = `/api/storage/{id}/usages`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageOrphansScanPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/storage/orphans/scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageRecompressAllPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/storage/recompress-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [fileName] 
         * @param {string} [folder] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageUploadImagesPost: async (title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiStorageUploadImagesPost', 'title', title)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiStorageUploadImagesPost', 'file', file)
            const localVarPath = `/api/storage/upload/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (title !== undefined) { 
                localVarFormParams.append('Title', title as any);
            }

            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }

            if (folder !== undefined) { 
                localVarFormParams.append('Folder', folder as any);
            }

            if (taxonomyIds !== undefined) { 
                localVarFormParams.append('TaxonomyIds', taxonomyIds as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [fileName] 
         * @param {string} [folder] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageUploadPublicationsPost: async (title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiStorageUploadPublicationsPost', 'title', title)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiStorageUploadPublicationsPost', 'file', file)
            const localVarPath = `/api/storage/upload/publications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (title !== undefined) { 
                localVarFormParams.append('Title', title as any);
            }

            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }

            if (folder !== undefined) { 
                localVarFormParams.append('Folder', folder as any);
            }

            if (taxonomyIds !== undefined) { 
                localVarFormParams.append('TaxonomyIds', taxonomyIds as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageApi - functional programming interface
 */
export const StorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [path] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageBrowseGet(path?: string, page?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsStorageBrowseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageBrowseGet(path, page, limit, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageBrowseGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageByKeyGet(key?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageByKeyGet(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageByKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [folder] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageGet(folder?: string, limit?: number, page?: number, search?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StorageObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageGet(folder, limit, page, search, taxonomyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdDownloadGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdDownloadGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {BCCADMINAPIControllersStorageMetadataUpdate} [bCCADMINAPIControllersStorageMetadataUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdPut(id: string, bCCADMINAPIControllersStorageMetadataUpdate?: BCCADMINAPIControllersStorageMetadataUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdPut(id, bCCADMINAPIControllersStorageMetadataUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdRecompressPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdRecompressPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdRecompressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {StorageTaxonomyUpdate} [storageTaxonomyUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdTaxonomiesPut(id: string, storageTaxonomyUpdate?: StorageTaxonomyUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdTaxonomiesPut(id, storageTaxonomyUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdTaxonomiesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageIdUsagesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageIdUsagesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageIdUsagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageOrphansScanPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINServicesServicesMediaOrphanReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageOrphansScanPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageOrphansScanPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageRecompressAllPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsStorageRecompressAllResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageRecompressAllPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageRecompressAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [fileName] 
         * @param {string} [folder] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageUploadImagesPost(title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageUploadImagesPost(title, file, fileName, folder, taxonomyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageUploadImagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [fileName] 
         * @param {string} [folder] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStorageUploadPublicationsPost(title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStorageUploadPublicationsPost(title, file, fileName, folder, taxonomyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.apiStorageUploadPublicationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorageApi - factory interface
 */
export const StorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [path] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageBrowseGet(path?: string, page?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsStorageBrowseResponse> {
            return localVarFp.apiStorageBrowseGet(path, page, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageByKeyGet(key?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageByKeyGet(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [folder] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageGet(folder?: string, limit?: number, page?: number, search?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StorageObject>> {
            return localVarFp.apiStorageGet(folder, limit, page, search, taxonomyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStorageIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdDownloadGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStorageIdDownloadGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {BCCADMINAPIControllersStorageMetadataUpdate} [bCCADMINAPIControllersStorageMetadataUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdPut(id: string, bCCADMINAPIControllersStorageMetadataUpdate?: BCCADMINAPIControllersStorageMetadataUpdate, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageIdPut(id, bCCADMINAPIControllersStorageMetadataUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdRecompressPost(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageIdRecompressPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {StorageTaxonomyUpdate} [storageTaxonomyUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdTaxonomiesPut(id: string, storageTaxonomyUpdate?: StorageTaxonomyUpdate, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageIdTaxonomiesPut(id, storageTaxonomyUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageIdUsagesGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStorageIdUsagesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageOrphansScanPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINServicesServicesMediaOrphanReport> {
            return localVarFp.apiStorageOrphansScanPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageRecompressAllPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsStorageRecompressAllResult> {
            return localVarFp.apiStorageRecompressAllPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [fileName] 
         * @param {string} [folder] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageUploadImagesPost(title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageUploadImagesPost(title, file, fileName, folder, taxonomyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [fileName] 
         * @param {string} [folder] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStorageUploadPublicationsPost(title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObject> {
            return localVarFp.apiStorageUploadPublicationsPost(title, file, fileName, folder, taxonomyIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageApi - object-oriented interface
 */
export class StorageApi extends BaseAPI {
    /**
     * 
     * @param {string} [path] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageBrowseGet(path?: string, page?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageBrowseGet(path, page, limit, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageByKeyGet(key?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageByKeyGet(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [folder] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {string} [taxonomyIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageGet(folder?: string, limit?: number, page?: number, search?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageGet(folder, limit, page, search, taxonomyIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdDownloadGet(id: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdDownloadGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdGet(id: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {BCCADMINAPIControllersStorageMetadataUpdate} [bCCADMINAPIControllersStorageMetadataUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdPut(id: string, bCCADMINAPIControllersStorageMetadataUpdate?: BCCADMINAPIControllersStorageMetadataUpdate, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdPut(id, bCCADMINAPIControllersStorageMetadataUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdRecompressPost(id: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdRecompressPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {StorageTaxonomyUpdate} [storageTaxonomyUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdTaxonomiesPut(id: string, storageTaxonomyUpdate?: StorageTaxonomyUpdate, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdTaxonomiesPut(id, storageTaxonomyUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageIdUsagesGet(id: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageIdUsagesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageOrphansScanPost(options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageOrphansScanPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageRecompressAllPost(options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageRecompressAllPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} title 
     * @param {File} file 
     * @param {string} [fileName] 
     * @param {string} [folder] 
     * @param {string} [taxonomyIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageUploadImagesPost(title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageUploadImagesPost(title, file, fileName, folder, taxonomyIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} title 
     * @param {File} file 
     * @param {string} [fileName] 
     * @param {string} [folder] 
     * @param {string} [taxonomyIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStorageUploadPublicationsPost(title: string, file: File, fileName?: string, folder?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).apiStorageUploadPublicationsPost(title, file, fileName, folder, taxonomyIds, options).then((request) => request(this.axios, this.basePath));
    }
}

